import { SvgIcon, keyframes } from '@mui/material';

import { ReactComponent as FlowAiMark } from '../../Assets/flow-ai.svg';

interface AgenticChatActivityIconProps {
  animation: 'Active' | 'Inactive';
}

const activityPulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export function AgenticChatActivityIcon(props: AgenticChatActivityIconProps) {
  const { animation } = props;

  return (
    <SvgIcon
      component={FlowAiMark}
      inheritViewBox
      aria-hidden
      sx={{
        fontSize: 16,
        flexShrink: 0,
        color: animation === 'Active' ? 'primary.main' : 'inherit',
        animation: animation === 'Active' ? `${activityPulse} 1.5s ease-in-out infinite` : 'none',
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }}
    />
  );
}
